let Brands = [
    {
        ID: 1,
        Name: "GUESS",
    },
    {
        ID: 2,
        Name: "TOMMY HILFIGER",
    },
    {
        ID: 3,
        Name: "CARRERA",
    },
    {
        ID: 4,
        Name: "CERRUTI",
    },
    {
        ID: 5,
        Name: "MAX MARA",
    },
    {
        ID: 6,
        Name: "TOMMY JEANS",
    },
    {
        ID: 7,
        Name: "LA MATTA",
    },
    {
        ID: 8,
        Name: "LA MARTINA",
    },
    {
        ID: 9,
        Name: "BORBONESE",
    },
    {
        ID: 10,
        Name: "GENNY",
    },
    {
        ID: 11,
        Name: "HERMOSSA",
    },
    {
        ID: 12,
        Name: "RESERVE",
    },
    {
        ID: 13,
        Name: "DESPADA",
    },
    {
        ID: 14,
        Name: "JULIA BACKER",
    },
    {
        ID: 15,
        Name: "MASSIMO",
    },
    {
        ID: 16,
        Name: "ISABELLE",
    },
    {
        ID: 17,
        Name: "POLAR GLARE",
    },
    {
        ID: 18,
        Name: "OZZIE",
    },
    {
        ID: 19,
        Name: "LEXON",
    },
    {
        ID: 20,
        Name: "MOSCHINO",
    },
    {
        ID: 21,
        Name: "COCO SONG",
    },
    {
        ID: 22,
        Name: "MARC JACOBS",
    },
    {
        ID: 23,
        Name: "TOM TAILOR",
    },
    {
        ID: 24,
        Name: "BLANCIA",
    },
    {
        ID: 25,
        Name: "BETTY BARCLAY",
    },
    {
        ID: 26,
        Name: "OLIVERO CONTINI",
    },
    {
        ID: 27,
        Name: "ROLLING STONES",
    },
    {
        ID: 28,
        Name: "ESPRIT",
    },
    {
        ID: 29,
        Name: "CHARMANT",
    },
    {
        ID: 30,
        Name: "LX",
    },
    {
        ID: 31,
        Name: "ESTEL",
    },
    {
        ID: 32,
        Name: "ISABELLE",
    },
    {
        ID: 33,
        Name: "FABRICIO",
    },
    {
        ID: 34,
        Name: "COCO SONG",
    },
    {
        ID: 35,
        Name: "SOFLENS",
    },
    {
        ID: 36,
        Name: "PRIMASOFT",
    },
    {
        ID: 37,
        Name: "ZEISS",
    },
    {
        ID: 38,
        Name: "NEO",
    },
        {
        ID: 39,
        Name: "Ana Hickmann",
    },
        {
        ID: 40,
        Name: "Bullmon",
    },
    ];

export default Brands;
